module.exports = __webpack_public_path__ + "static/media/yaju.5d8c0c1f.jpeg";